var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stars-rating"},_vm._l((_vm.maxStars),function(star){return _c('span',{key:star,class:_vm.getStarClass(star)})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }